import Debug from 'debug'
import Account from './Account.js'

const debug = Debug('cbio.accounts')

export default (api) => ({
  list: async (query, options) => {
    debug('list()', query)
    const accounts = await api.list(Account.url(), query, options)
    return accounts.map(account => new Account(api, account))
  }
})

export { Account }
